module.exports = __webpack_public_path__ + "static/media/ad-history-table.3426fe15.jpg";